import { create } from 'services/api';
import get from 'lodash.get';

export const RECEIVE_NETWORK_PAYEE = 'create/network/payee/RECEIVE';

export const selectNetworkPayee = state => get(state, ['v2', 'network', 'items', '0'], null);

export const fetchNetworkPayees = () => dispatch => {
  return create.get(`/api-v3/network/payees`).then(response => {
    dispatch({ type: RECEIVE_NETWORK_PAYEE, payload: response.body });
  });
};

export default function reducer(state = null, action) {
  switch (action.type) {
    case RECEIVE_NETWORK_PAYEE:
      return action.payload;
    default:
      return state;
  }
}
